import { IftaFiling } from 'src/models';

export const WIZARD_STEPS = ['Period', 'Miles Source', 'Miles', 'Fuel', 'Review & Pay'];

// The filing record is the wizard state: refresh/resume derives the step.
export function activeStep(filing: IftaFiling): number {
  if (!filing.selectedQuarter) return 0;
  if (!filing.milesSource) return 1;
  if (!filing.mileLines || filing.mileLines.length === 0) return 2;
  if (!filing.fuelLines || filing.fuelLines.length === 0) return 3;
  return 4;
}

export function quarterLabel(quarter: string) {
  return quarter || 'Not selected';
}

// Completion is per step, not positional: a skipped step stays numbered even
// when the user is past it.
export function stepCompleted(filing: IftaFiling, step: number): boolean {
  switch (step) {
    case 0:
      return !!filing.selectedQuarter;
    case 1:
      return !!filing.milesSource;
    case 2:
      return filing.mileLines.length > 0;
    case 3:
      return filing.fuelLines.length > 0;
    case 4:
      return filing.paymentStatus === 'paid';
    default:
      return false;
  }
}
